import { useTranslation } from 'react-i18next';

interface PasswordRequirementsProps {
  errors: string[];
}

export function PasswordRequirements({ errors }: PasswordRequirementsProps) {
  const { t } = useTranslation();
  
  if (errors.length === 0) return null;

  return (
    <ul className="text-sm text-red-500 list-disc list-inside space-y-1">
      {errors.map((error, index) => (
        <li key={index}>{t(error)}</li>
      ))}
    </ul>
  );
} 